import logo from "./logo.svg";
import "./App.css";
import TaxiServiceAccross from "./Components/TaxiServiceAccross/TaxiServiceAccross";
import PricePlan from "./Components/PricePlan/PricePlan";
import EffortlessBooking from "./Components/EffortlessBooking/EffortlessBooking";
import WhyChooseKarline from "./Components/WhyChooseKarline/WhyChooseKarline";
import Concert from "./Components/Concert/Concert";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SliderTestimonial from "./Components/SliderTestimonials/SliderTestimonial";
import ContactUs from "./Components/ContactUs/ContactUs";
import Footer from "./Components/Footer/Footer";
import LandingPage from "./Pages/LandingPage";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BookPage from "./Pages/BookPage";
import RegisterBooking from "./Pages/RegisterBooking";
import PaymentPage from "./Pages/PaymentPage";
import VehiclePageAdmin from "./Pages/VehiclePageAdmin";
import AdminDrivers from "./AdminComponents/AdminDrivers/AdminDrivers";
import AdminCustomers from "./AdminComponents/AdminCustomers/AdminCustomers";
import AdminPricing from "./AdminComponents/AdminPricing/AdminPricing";
import AdminDashBoard from "./AdminComponents/AdminDashBoard/AdminDashBoard";
import BookingAdmin from "./AdminComponents/BookingAdmin/BookingAdmin";
import CustomerLogin from "./Pages/CustomerLogin";
import RegisterCustomer from "./Components/RegisterCustomer/RegisterCustomer";
import RegisterPage from "./Pages/RegisterPage";
import ProfilePage from "./Pages/ProfilePage";
import MyBookingsPage from "./Pages/MyBookingsPage";
import DriverDashBoardPage from "./Pages/DriverDashBoardPage";
import ProfileDriver from "./DriverComponents/ProfileDriver/ProfileDriver";
import DriverVehiclePage from "./Pages/DriverVehiclePage";
import DriverLogin from "./DriverComponents/DriverLogin/DriverLogin";
import DriverLoginPage from "./Pages/DriverLoginPage";
import AdminLoginPage from "./Pages/AdminLoginPage";
import OurServicesPage from "./Pages/OurServicesPage";
import OurFleetsPage from "./Pages/OurFleetsPage";
import DriveWithUSPage from "./Pages/DriveWithUSPage";
import ContactUsCompPage from "./Pages/ContactUsCompPage";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/vehicle-booking" element={<BookPage />} />
          <Route path="/register-booking" element={<RegisterBooking />} />
          <Route path="/payment" element={<PaymentPage />} />

          <Route path="/customer/login" element={<CustomerLogin />} />
          <Route path="/customer/register" element={<RegisterPage />} />
          <Route path="/customer/profile" element={<ProfilePage />} />
          <Route path="/customer/myBookings" element={<MyBookingsPage />} />

          <Route path="/customer/ourServices" element={<OurServicesPage/>} />
          <Route path="/customer/ourFleets" element={<OurFleetsPage/>} />
          <Route path="/customer/driveWithUs" element={<DriveWithUSPage/>} />
          <Route path="/customer/contactUs" element={<ContactUsCompPage/>} />
    

          <Route path="/admin/vehicles" element={<VehiclePageAdmin />} />
          <Route path="/admin/drivers" element={<AdminDrivers />} />
          <Route path="/admin/customers" element={<AdminCustomers />} />
          <Route path="/admin/pricing" element={<AdminPricing />} />
          <Route path="/admin/dashboard" element={<AdminDashBoard />} />
          <Route path="/admin/bookings" element={<BookingAdmin />} />

          <Route path="/driver/dashboard" element={<DriverDashBoardPage />} />
          <Route path="/driver/profile" element={<ProfileDriver />} />
          <Route path="/driver/vehicle" element={<DriverVehiclePage />} />
          <Route path="/driver/login" element={<DriverLoginPage />} />

          <Route path="/admin/login" element={<AdminLoginPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
